import { createSelector } from "@reduxjs/toolkit";
export const referralState = (state) => state.referrals;

export const referralsSelectors = createSelector(referralState, (state) => state);
